import { domReady, initBlockEnterKeyForDisabledButton, setButtonStateDuringActivity } from 'utilities/dom';
import { populateStateProvince } from 'ui/forms';

domReady(() => {

	window.initFormValidation(true, '#warrantyForm');

	const $countrySelect = $('#ddlCompanyCountry');
	const $stateSelect = $('#ddlCompanyState');
	const showAddressBtn = document.querySelector('.showAnotherAddressField');
	const showCountryField = document.querySelector('.showCountryField');
	const showAddressTwo = document.querySelector('.companyAddress');
	const contryField = document.querySelector('.countryField');

	// populate states
	populateStateProvince($stateSelect, $countrySelect, $stateSelect.val() || null);

	$countrySelect.on('change', () => {

		populateStateProvince($stateSelect, $countrySelect, null);

	});

	const submitFormBtn = document.getElementById('submitActivateWarrantyBtn');

	if (showAddressBtn) {

		showAddressBtn.addEventListener('click', (event) => {

			event.preventDefault();
			showAddressBtn.classList.add('hidden');
			if (showAddressTwo) {

				showAddressTwo.classList.remove('hidden');

			}
			showAddressBtn.setAttribute('aria-expanded', true);

		});

	}
	if (showCountryField) {

		showCountryField.addEventListener('click', (event) => {

			event.preventDefault();
			showCountryField.classList.add('hidden');
			if (contryField) {

				contryField.classList.remove('hidden');

			}
			showCountryField.setAttribute('aria-expanded', true);

		});

	}

	// add event listener to block Enter key for aria-disabled buttons
	initBlockEnterKeyForDisabledButton(submitFormBtn);

	// regular form submission
	submitFormBtn.addEventListener('click', (e) => {

		const isFormValid = $(submitFormBtn.form).valid();
		if (isFormValid) {

			// set submit button state before form is submitted
			setButtonStateDuringActivity(submitFormBtn);

			// continue form submission
			return true;

		}

		// cancel form submission
		return false;

	});

});
